import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormTypeToSelect from '../form/FormTypeToSelect';
import EquipmentContainer from '../../containers/Equipment';
import EquipmentAssignmentContainer from '../../containers/EquipmentAssignment';
import UserAssignmentContainer from '../../containers/UserAssignment';
import { getAssignmentBreakdowns } from '../assignments/assignmentHelper';
import { getEquipmentAssignmentType } from '../../libs/user';
import Grid from '@material-ui/core/Grid';
import { gridMargin } from '../form/general';
import moment from 'moment';

// const JOEY_USER_ID  = 377;
// const DWP_USER_ID = 1;

function makeOption(equipment, locationName) {
	const { equipmentId, display, geoTabComment } = equipment;
	return {
		value: equipmentId,
		label: `${display} - (${geoTabComment})` + (locationName ? ` : @${locationName}` : ''),
	};
}

class SmartEquipmentSelect extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			assignmentBreakdowns: undefined,
		};
	}

	componentDidMount() {
		const {
			equipments,
			searchEquipments,
			equipmentAssignments,
			searchEquipmentAssignments,
		} = this.props;

		if (_.isEmpty(equipments)) {
			searchEquipments();
		}

		if (_.isEmpty(equipmentAssignments)) {
			searchEquipmentAssignments();
		}

		const { assignmentBreakdowns } = this.state;
		if (!_.isEmpty(equipmentAssignments) && _.isUndefined(assignmentBreakdowns)) {
			this.formatAssignmentBreakdowns();
		}
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const { equipmentAssignments } = this.props;
		const { assignmentBreakdowns } = this.state;
		if (!_.isEmpty(equipmentAssignments) && _.isUndefined(assignmentBreakdowns)) {
			this.formatAssignmentBreakdowns();
		}
	}

	formatAssignmentBreakdowns = () => {
		const { userMap, locationMap, userAssignments, equipmentAssignments } = this.props;

		const { assignmentBreakdowns } = getAssignmentBreakdowns({
			userMap,
			locationMap,
			userAssignments,
			equipmentAssignments,
		});

		this.setState({
			assignmentBreakdowns,
		});
	};

	render() {
		const {
			equipments,
			filterType,
			showRetired = false,
			equipmentAssignments = [],
			includeEquipmentIds = [],
			equipmentAssignmentId,
			locationMap,
		} = this.props;

		const makeLoc = (locationId) => {
			const location = locationMap[locationId] || { display: 'Unknown' };
			return location.display;
		};

		const options = [];
		if (filterType === 'availableForCSchedule') {
			const { wantTypeA, wantTypeB, selectedLocationId } = this.props;

			if (!selectedLocationId) {
				return this.renderPickPlease({ message: 'Select a location for a list of trucks' });
			}

			const now = moment();
			const ignoreEquipmentById = {};
			const goodEquipmentById = {};
			equipmentAssignments.forEach((equipmentAssignment) => {
				const {
					equipmentAssignmentTypeId,
					endDate,
					equipmentId,
					equipmentId2,
					locationId,
				} = equipmentAssignment;

				if (endDate && moment(endDate).isBefore(now)) {
					return;
				}

				if (selectedLocationId !== locationId) {
					return;
				}

				const equipmentAssignmentType = getEquipmentAssignmentType({ equipmentAssignmentTypeId });

				//we might be updating an existing assignment
				if (
					equipmentAssignmentId &&
					equipmentAssignmentId === equipmentAssignment.equipmentAssignmentId
				) {
					if (wantTypeA && equipmentAssignmentType.isTypeA) {
						goodEquipmentById[equipmentId] = true;
					}
					if (wantTypeB && equipmentAssignmentType.isTypeB) {
						goodEquipmentById[equipmentId2] = true;
					}
					return;
				}

				if (equipmentAssignmentType.isTypeC) {
					const { equipmentId2 } = equipmentAssignment;
					ignoreEquipmentById[equipmentId] = true;
					ignoreEquipmentById[equipmentId2] = true;
					return;
				}

				if (wantTypeA && equipmentAssignmentType.isTypeA) {
					goodEquipmentById[equipmentId] = true;
				}
				if (wantTypeB && equipmentAssignmentType.isTypeB) {
					goodEquipmentById[equipmentId] = true;
				}
			});

			const available = { label: 'Available Trucks', options: [] };
			const unavailable = {
				label: <div style={{ color: 'red' }}>Already Used Trucks (be sure to fix)</div>,
				options: [],
			};
			_.sortBy(equipments, 'display').forEach((equipment) => {
				const { equipmentId, status } = equipment;
				if (!showRetired && status === 'retired') {
					return;
				}
				if (!goodEquipmentById[equipmentId]) {
					unavailable.options.push(makeOption(equipment));
					return;
				}
				if (ignoreEquipmentById[equipmentId]) {
					unavailable.options.push(makeOption(equipment));
					return;
				}

				available.options.push(makeOption(equipment));
			});
			options.push(available, unavailable);
		} else if (filterType === 'availableTruckNewAOrBSchedule') {
			const { wantTypeA } = this.props;

			// Go through and filter out any not current ones
			// and check to only show trucks opposite the C schedules
			const now = moment();
			const alreadyTaken = {};
			equipmentAssignments.forEach((equipmentAssignment) => {
				const { endDate, equipmentAssignmentTypeId, locationId } = equipmentAssignment;
				if (endDate && moment(endDate).isBefore(now)) {
					return;
				}

				// If the truck is on a C schedule and on a different schedule yo can't use it
				const equipmentAssignmentType = getEquipmentAssignmentType({ equipmentAssignmentTypeId });

				if (equipmentAssignmentType.isTypeC) {
					if (wantTypeA) {
						alreadyTaken[equipmentAssignment.equipmentId2] = makeLoc(locationId);
					} else {
						alreadyTaken[equipmentAssignment.equipmentId] = makeLoc(locationId);
					}
				} else {
					alreadyTaken[equipmentAssignment.equipmentId] = makeLoc(locationId);
				}
			});

			for (const includeEquipmentId of includeEquipmentIds) {
				delete alreadyTaken[includeEquipmentId];
			}
			const available = { label: 'Available Trucks', options: [] };
			const unavailable = {
				label: <div style={{ color: 'red' }}>Already Used Trucks (be sure to fix)</div>,
				options: [],
			};
			_.sortBy(equipments, 'display').forEach((equipment) => {
				const { equipmentId, status } = equipment;
				if (!showRetired && status === 'retired') {
					return;
				}
				if (alreadyTaken[equipmentId]) {
					unavailable.options.push(makeOption(equipment, alreadyTaken[equipmentId]));
					return;
				}

				available.options.push(makeOption(equipment));
			});
			options.push(available, unavailable);
		}

		return <FormTypeToSelect {...this.props} options={options} />;
	}

	renderPickPlease = ({ message }) => {
		const { gridProps } = this.props;
		if (gridProps) {
			_.defaults(gridProps, { xs: 12 });
			return (
				<Grid item {...gridProps} style={gridMargin}>
					{message}
				</Grid>
			);
		} else {
			return message;
		}
	};
}

SmartEquipmentSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,
	currentUserAssignmentId: PropTypes.number,
	includeEquipmentIds: PropTypes.array,

	classes: PropTypes.object,
	helpText: PropTypes.string,
	groupBy: PropTypes.string,
	openTrucks: PropTypes.array,
	includeTbd: PropTypes.bool,
	onlyShowActive: PropTypes.bool,
	equipmentAssignmentId: PropTypes.number,
};

SmartEquipmentSelect.defaultProps = {
	label: 'Equipment',
	equipments: [],
	includeTbd: false,
	onlyShowActive: false,
};

export default _.flow([EquipmentAssignmentContainer, UserAssignmentContainer, EquipmentContainer])(
	SmartEquipmentSelect
);
